/**
 * COMING-SOON.MODAL
 * Feature announced but not available yet
 */
import Modal from "@/components/modal"

interface OwnProps {
  onClose: () => void
}

function ComingSoonModal(props: OwnProps) {
  return (
    <Modal title="Disponible prochainement" onClose={props.onClose} onNext={props.onClose} onNextCta="OK">
      <p>Cette fonctionnalité sera disponible prochainement.</p>
    </Modal>
  )
}

export default ComingSoonModal
